
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channel]/archive/[...article]",
      function () {
        return require("private-next-pages/[channel]/archive/[...article].tsx");
      }
    ]);
  